import { useSetSearchMsgSelectedSendTime } from '../searchMsgSelectedMsg';
import { useMutation } from '@tanstack/react-query';
import { getMsgById } from 'services/api/conversation.convList';

export const useScrollToMsg = () => {
  const setSearchMsgSelectedSendTime = useSetSearchMsgSelectedSendTime();

  const { mutateAsync: getMessageById, isLoading } = useMutation({
    mutationFn: (msgId: string) => getMsgById(msgId),
  });

  return async (msgId: string) => {
    if (isLoading) {
      return;
    }
    const resp = await getMessageById(msgId);
    setSearchMsgSelectedSendTime({ sendTime: `${resp.sendTime}`, msgId });
  };
};
